import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=13cf957a&scoped=true"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=13cf957a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf957a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13cf957a')) {
      api.createRecord('13cf957a', component.options)
    } else {
      api.reload('13cf957a', component.options)
    }
    module.hot.accept("./Coupons.vue?vue&type=template&id=13cf957a&scoped=true", function () {
      api.rerender('13cf957a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Coupons.vue"
export default component.exports